/* global google */

function haversineDistance(lat1, lon1, lat2, lon2) {
    const toRad = (x) => (x * Math.PI) / 180;
    const R = 3958.8; // Radius of Earth in miles
    const dLat = toRad(lat2 - lat1);
    const dLon = toRad(lon2 - lon1);
    const a =
        Math.sin(dLat / 2) ** 2 +
        Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLon / 2) ** 2;
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c;
}

const GetDistance = async (clientLocation, musicologieLocations) => {
    let result;

    const clientCoords = clientLocation.coords;
    const maxMiles = 100;

    // Filter locations by straight-line distance
    const filteredLocations = musicologieLocations.filter((loc) => {
        const locCoords = {
            latitude: loc.latitude,
            longitude: loc.longitude,
        };
        if (!locCoords) return false;
        const dist = haversineDistance(
            clientCoords.latitude,
            clientCoords.longitude,
            locCoords.latitude,
            locCoords.longitude
        );

        return dist <= maxMiles;
    });

    if (filteredLocations.length === 0) return [];

    try {
        const rawResult = await searchLocation(
            clientLocation,
            filteredLocations
        );
        result = rawResult.rows[0].elements.map((res, idx) => {
            return {
                id: filteredLocations[idx].id,
                distance: res.distance.text,
                duration: res.duration.text,
                value: res.distance.value,
            };
        });
    } catch (err) {
        console.log("An error occurred", err);
        result = null;
    }

    return result;
};

// Auxiliary functions
// wrap google api's callback to an async function
const searchLocation = async (clientLocation, musicologieLocations) => {
    //console.log(clientLocation, musicologieLocations);
    let promise = await new Promise((resolve, reject) => {
        var measureDistance = (distances, status) => {
            if (status !== google.maps.DistanceMatrixStatus.OK) {
                reject(status);
            }
            resolve(distances);
        };

        var service = new google.maps.DistanceMatrixService();
        const clientCoords = clientLocation.coords;

        service.getDistanceMatrix(
            {
                origins: [
                    new google.maps.LatLng(
                        clientCoords.latitude,
                        clientCoords.longitude
                    ),
                ],
                destinations: musicologieLocations.map((e) => e.address),
                travelMode: "DRIVING",
                unitSystem: google.maps.UnitSystem.IMPERIAL,
                avoidTolls: true,
            },
            measureDistance
        );
    }).catch(function (err) {
        throw err;
    });

    return promise;
};

export { GetDistance };
